import React from 'react';
import type { ReputationGeneratedTemplate } from '@reach/shared-types/automation-template';
import { TemplateProgressGroup } from './TemplateProgressGroup';
import styles from './reputation-defaults-dialog.module.css';

interface GenerationProgressListProps {
  templates: ReputationGeneratedTemplate[];
}

export const GenerationProgressList: React.FC<GenerationProgressListProps> = ({ templates }) => (
  <ul className={styles.templateProgressList}>
    {templates.map(template => (
      <TemplateProgressGroup key={template.templateId} template={template} />
    ))}
  </ul>
);
